import HeaderCalendarView from './HeaderCalendarView.vue';

export default HeaderCalendarView;
